import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchServiceDashboardData } from '../../../../redux/reducers/serviceDashboardSlice';

function SummaryCards() {
  const dispatch = useDispatch();
  const { loading, nonmedicalCount, medicalCount } = useSelector((state) => state.serviceDashboard);

  useEffect(() => {
    dispatch(fetchServiceDashboardData());
  }, [dispatch]);

  // Calculate total non-medical count from Week, Month, Year
  // const nonMedicalCount =
  //   (usednonmedical?.Week?.length || 0) +
  //   (usednonmedical?.Month?.length || 0) +
  //   (usednonmedical?.Year?.length || 0);

  const cards = [
    { title: 'Medical Services', value: medicalCount ?? 0 },
    { title: 'Non-Medical Services', value: nonmedicalCount ?? 0 },
  ];

  if (loading) {
    return <p>Loading...</p>;
  }

  return (
    <div style={{ display: 'flex', gap: '20px' }}>
      {cards.map((card, i) => (
        <div
          key={i}
          style={{
            padding: '1px 20px 20px 20px',
            background: '#e9f2ff',
            borderRadius: '16px',
            flex: 1,
          }}
        >
          <h4>{card.title}</h4>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <h2 style={{ margin: 0 }}>{card?.value}</h2>
          </div>
        </div>
      ))}
    </div>
  );
}

export default SummaryCards;